import React from 'react';
import { Tooltip } from 'antd';
import './WordStyleRibbon.css';

export type RibbonTabId = 'home' | 'layout' | 'design';

export const RIBBON_TABS: Array<{ id: RibbonTabId; title: string; icon: React.ReactNode }> = [];

export function WordStyleEditorShell({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={['word-style-editor', className].filter(Boolean).join(' ')}>{children}</div>;
}

export function RibbonTabs({
  tabs,
  activeTab,
  onChange,
}: {
  tabs: Array<{ id: RibbonTabId; title: string; icon: React.ReactNode }>;
  activeTab: RibbonTabId;
  onChange: (tab: RibbonTabId) => void;
}) {
  return (
    <div className="word-ribbon-tabs" role="tablist">
      {tabs.map((tab) => (
        <Tooltip key={tab.id} title={tab.title}>
          <button
            type="button"
            role="tab"
            aria-label={tab.title}
            aria-selected={activeTab === tab.id}
            className={`word-ribbon-tab-btn${activeTab === tab.id ? ' active' : ''}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.icon}
          </button>
        </Tooltip>
      ))}
    </div>
  );
}

export function RibbonPanel({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={['word-ribbon-panel', className].filter(Boolean).join(' ')}>{children}</div>;
}

export function RibbonGroup({
  title,
  icon,
  children,
}: {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="word-ribbon-group">
      <div className="word-ribbon-group-body">{children}</div>
      <Tooltip title={title}>
        <div className="word-ribbon-group-icon" aria-label={title}>
          {icon}
        </div>
      </Tooltip>
    </div>
  );
}

export function RibbonDivider() {
  return <div className="word-ribbon-divider" aria-hidden />;
}

export function RibbonIconButton({
  title,
  active,
  onClick,
  children,
  className,
}: {
  title: string;
  active?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Tooltip title={title} placement="top" mouseEnterDelay={0.3}>
      <button
        type="button"
        aria-label={title}
        className={`word-ribbon-icon-btn${active ? ' active' : ''}${className ? ` ${className}` : ''}`}
        onClick={onClick}
        aria-pressed={active}
      >
        {children}
      </button>
    </Tooltip>
  );
}
